import React from 'react';

// Provides { sketch: BackgroundInstance | null } to all descendants.
// The value object is a stable mutable container — consumers read
// contextValue.sketch imperatively without needing context re-renders.
const SketchContext = React.createContext(null);

export default SketchContext;
